/* src/app/shared/components/needs-principal-attestation-dialog/needs-principal-attestation-dialog.component.scss */
.modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
}
.modal {
  background-color: #fff;
  width: 100%;
  text-align: center;
  padding: 20px;
}
.modal-heading {
  font-size: 24px;
  color: #003a71;
}
.dialog-buttons {
  display: flex;
  justify-content: center;
}
.dialog-buttons button:not(:first-child) {
  margin-left: 40px;
}
.btn-save,
.btn-cancel {
  padding: 10px;
  margin: 0 10px;
  width: 120px;
  cursor: pointer;
  border: none;
  border-radius: 20px;
  font-size: 14px;
}
.btn-save {
  background-color: #003a71;
  color: #fff;
}
.btn-cancel {
  background-color: #f4f0e5;
}
.btn-save:hover,
.btn-cancel:hover {
  opacity: 0.8;
}
.missing__cert__Areas {
  color: red;
  margin-left: 1em;
  font-size: 0.8em;
}
/*# sourceMappingURL=needs-principal-attestation-dialog.component.css.map */
